"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIXED_POINT = Math.pow(10, 8);
exports.TRANSFER_FEE = exports.FIXED_POINT * 0.1;
exports.IN_TRANSFER_FEE = exports.FIXED_POINT * 0.1;
exports.OUT_TRANSFER_FEE = exports.FIXED_POINT * 0.1;
exports.SIGNATURE_FEE = exports.FIXED_POINT * 5;
exports.DELEGATE_FEE = exports.FIXED_POINT * 25;
exports.VOTE_FEE = exports.FIXED_POINT * 1;
exports.MULTISIGNATURE_FEE = exports.FIXED_POINT * 5;
exports.MULTISIGNATURE_MAX_LIFETIME = 72;
exports.MULTISIGNATURE_MIN_LIFETIME = 1;
exports.MULTISIGNATURE_MAX_KEYSGROUP = 15;
exports.MULTISIGNATURE_MIN_KEYSGROUP = 1;
exports.DAPP_FEE = exports.FIXED_POINT * 25;
exports.USERNAME_MAX_LENGTH = 20;
exports.BYTESIZES = {
  TYPE: 1,
  TIMESTAMP: 4,
  MULTISIGNATURE_PUBLICKEY: 32,
  RECIPIENT_ID: 8,
  AMOUNT: 8,
  SIGNATURE_TRANSACTION: 64,
  SECOND_SIGNATURE_TRANSACTION: 64,
  DATA: 64
};
exports.EPOCH_TIME = new Date(Date.UTC(2016, 4, 24, 17, 0, 0, 0));
exports.EPOCH_TIME_MILLISECONDS = exports.EPOCH_TIME.getTime();
var MS_FACTOR = 1000;
exports.EPOCH_TIME_SECONDS = Math.floor(exports.EPOCH_TIME.getTime() / MS_FACTOR);
var MAX_EIGHT_BYTE_NUMBER = '18446744073709551615';
exports.MAX_ADDRESS_NUMBER = MAX_EIGHT_BYTE_NUMBER;
exports.MAX_TRANSACTION_ID = MAX_EIGHT_BYTE_NUMBER;
exports.MAX_TRANSACTION_AMOUNT = '9223372036854775807';
exports.UNCONFIRMED_TRANSACTION_TIMEOUT = 10800;
exports.UNCONFIRMED_MULTISIG_TRANSACTION_TIMEOUT = 10800 * 8;
exports.MAX_MULTISIG_SIGNATURES = 15;
exports.MAX_PUBLIC_KEY_LENGTH = 32;
exports.MAX_TRANSFER_ASSET_DATA_LENGTH = 64;